/**
 * Total miles for a weekly checklist: sum of truckMileages rows when present, else legacy single odometer pair.
 * @param {object} checklist
 * @returns {number}
 */
export function getTotalWeeklyMiles(checklist) {
    if (!checklist) return 0;
    const tm = checklist.truckMileages;
    if (Array.isArray(tm) && tm.length > 0) {
        return tm.reduce((sum, row) => {
            const d = Number(row.mileageEnd) - Number(row.mileageStart);
            return sum + (Number.isFinite(d) ? d : 0);
        }, 0);
    }
    const end = Number(checklist.mileageEnd);
    const start = Number(checklist.mileageStart);
    if (Number.isFinite(end) && Number.isFinite(start)) return end - start;
    return 0;
}

export function formatTotalWeeklyMiles(checklist, decimals = 1) {
    const n = getTotalWeeklyMiles(checklist);
    return Number.isInteger(n) && decimals === 1 ? String(n) : n.toFixed(decimals);
}

function namedTruck(truck) {
    if (!truck || typeof truck !== 'object') return '';
    const unit = truck.unitNumber || truck.truckNumber || '';
    const rest = [truck.make, truck.model].filter(Boolean).join(' ');
    return `${unit} ${rest}`.trim();
}

function truckId(truck) {
    if (truck == null) return '';
    if (typeof truck === 'object') return String(truck._id || truck.id || '');
    return String(truck);
}

/** Mileage-row label. Uses the checklist truck when the row has no unit number and it is that truck, or the only row. */
export function mileageRowTruckLabel(row, idx, checklist) {
    const named = namedTruck(row?.truck);
    if (named) return named;
    const rows = Array.isArray(checklist?.truckMileages) ? checklist.truckMileages : [];
    const mainName = namedTruck(checklist?.truck);
    const sameTruck = truckId(row?.truck) && truckId(row.truck) === truckId(checklist?.truck);
    if (mainName && (rows.length === 1 || sameTruck)) return mainName;
    return `Truck ${idx + 1}`;
}
